import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transform',
    standalone: false
})
export class TransformPipe implements PipeTransform {
    public transform<T, K>(value: T, transformFunc: (value: T) => K): K {
        return transformFunc(value);
    }
}
